"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunctuationBoundary = void 0;
exports.PunctuationBoundary = {
    Circle: "\u3002",
    FullWidthComma: "\uFF0C",
    Dot: ".",
    Exclamation: "!",
    Question: "?",
    Semicolon: ";",
    Parenthesis: ")",
    ArabicComma: "\u060C",
    UrduFullStop: "\u06D4",
    BengaliFullStop: "\u0964",
    DoubleDanda: "\u0965",
    Pipe: "|",
    DoublePipe: "||",
    HalfWidthComma: ",",
    Colon: ":",
};
